/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposMovimientos from 'Infotrack@Modelos/smartStock/tiposMovimientos/entidades/tiposMovimientos';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import TiposMovimientosCM from '../controladorModelo/tiposMovimientosCM';
import { IFormularioTiposMovimientosCVProps } from '../interfaces';
import { acciones, IEstadoTiposMovimientos } from '../reductorTiposMovimientos';
import FormularioTiposMovimientosVista from '../vista/formularioTiposMovimientosVista';
import { useSelector } from 'react-redux';

const estadoInicial: ITiposMovimientos = {
    EmpresaId: '',
    TipoMovimientoDescripcion: '',
    Estado: 1,
    AgenciaId: '',
};
const tiposMovimientosCM = new TiposMovimientosCM();

const FormularioTiposMovimientosCV: React.FunctionComponent<IFormularioTiposMovimientosCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadTiposMovimientos }, dispatch] = useProveedor<
        IEstadoTiposMovimientos
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITiposMovimientos>(estadoInicial);

    React.useEffect(() => {
        if (entidadTiposMovimientos && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTiposMovimientos);
        } else {
            reiniciar();
        }
    }, [entidadTiposMovimientos]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTiposMovimientos = () => {
        if (tiposMovimientosCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTiposMovimientos,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTiposMovimientos = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tiposMovimientosCM
                .crearTiposMovimientos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            tiposMovimientosCM
                .editarTiposMovimientos({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioTiposMovimientosVista
            accionCrearEditar={confirmarCreacionEdicionTiposMovimientos}
            cambiarInfoFomulario={alCambiarValor}
            tiposMovimientos={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioTiposMovimientosCVProps => ({ IdEmpresa: usuarioInformacion!.IdEmpresa });

export default connect<IFormularioTiposMovimientosCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioTiposMovimientosCV);
